<!-- Скрытое отображение записи или показателя -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="stroke"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M3 14.5c2.4-2.7 5.4-4 9-4s6.6 1.3 9 4" />
    <path d="M6 17l-1.5 2" />
    <path d="M10 18l-.5 2.5" />
    <path d="M14 18l.5 2.5" />
    <path d="M18 17l1.5 2" />
  </svg>
</template>

<script>
export default {
  name: "EyeOffIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
